module.exports = __webpack_public_path__ + "static/media/cloud_watch2.2d593649.png";